import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';

import {
  provideRouter,
  RouterLink,
  RouterLinkActive,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withRouterConfig,
  withViewTransitions,
} from '@angular/router';

import {
  AvatarComponent,
  BadgeComponent,
  DropdownComponent,
  DropdownDividerDirective,
  DropdownItemDirective,
  DropdownModule,
  SidebarModule,
} from '@coreui/angular';
import { IconSetService } from '@coreui/icons-angular';
import { routes } from './app.routes';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { DssInputComponent } from '@assets/mydirective/dss-input/dss-input.component';
import {
  decimalDirective,
  DTFormatDirective,
  noWhiteSpaceDirective,
  NumberOnlyDirective,
  PercentDirective,
} from '@assets/mydirective/mydirective.directive';
import { UserPermissions } from '@assets/services/services';

import { provideClientHydration, withEventReplay } from '@angular/platform-browser';

import { provideNoopAnimations } from '@angular/platform-browser/animations';
import localeIn from '@angular/common/locales/en-IN';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideNoopAnimations(),
    provideClientHydration(withEventReplay()),

    provideHttpClient(withFetch()),

    provideRouter(
      routes,
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
      withViewTransitions()
      // ❌ removed withEnabledBlockingInitialNavigation()
    ),

    DropdownDividerDirective,
    DssInputComponent,
    BadgeComponent,
    DropdownComponent,
    DropdownDividerDirective,
    DropdownItemDirective,
    AvatarComponent,
    decimalDirective,
    UserPermissions,
    NumberOnlyDirective,
    DTFormatDirective,
    noWhiteSpaceDirective,
    PercentDirective,
    RouterLink,
    RouterLinkActive,
    importProvidersFrom(SidebarModule, DropdownModule),
    IconSetService,
    { provide: localeIn, useValue: 'en-IN' },
  ],
};
